import { useSearch } from "@tanstack/react-router";
import { Route } from "@/routes/__root";
import { ChangeOfBrokerDialog } from "@crm/components/portfolio/reports/change-of-broker";
import { AddSecondHolderDialog } from "@crm/components/clients/add-second-holder-dialog";
import {
  DEADLINE,
  SelfDeclarationForm,
  SIGNUP_DATE_CUTOFF,
} from "@core/components/self-declaration-form";
import { useDistributorProfile } from "creso-core/hooks";
import { DialogContent, V2Dialog } from "web-design-system";
import { useEffect, useState } from "react";
import { useAuthContext } from "@/providers/auth-provider";
import { endOfDay, isAfter } from "date-fns";

export function CoreDialogs() {
  const search = useSearch({ from: Route.id });
  return (
    <>
      {search.modal === "change-of-broker" ? <ChangeOfBrokerDialog /> : null}
      {/* Global so joint-holder status banners work on any page (e.g. family) */}
      {search.modal === "add-second-holder" ? <AddSecondHolderDialog /> : null}
      <SelfDeclarationAutoDialog />
    </>
  );
}

const SHOWN_DATE_KEY = (arnCode: string) =>
  `mfd-self-declaration-shown-${arnCode}`;

function SelfDeclarationAutoDialog() {
  const [open, setOpen] = useState(false);
  const { user } = useAuthContext();
  const { data: profile } = useDistributorProfile();

  useEffect(() => {
    if (!profile) return;
    if (user.user_type !== "distributor") return;
    if (isAfter(new Date(user.date_joined), endOfDay(SIGNUP_DATE_CUTOFF)))
      return;
    if (profile.declaration_link) return;
    if (isAfter(new Date(), endOfDay(DEADLINE))) return;
    try {
      const shownToday =
        localStorage.getItem(SHOWN_DATE_KEY(user.username)) ===
        new Date().toDateString();
      if (shownToday) return;
      setOpen(true);
      localStorage.setItem(
        SHOWN_DATE_KEY(user.username),
        new Date().toDateString()
      );
    } catch {
      // localStorage unavailable — show dialog
      setOpen(true);
    }
  }, [profile, user]);

  if (!profile) return null;

  return (
    <V2Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-lg p-0 gap-0 max-h-[90dvh] flex flex-col overflow-hidden">
        <div className="overflow-y-auto px-6 pt-6 flex flex-1">
          <SelfDeclarationForm
            details={{
              name: profile.name,
              arnCode: profile.arn_code,
              phoneNumber: profile.phone_number,
              email: profile.email,
            }}
            otpVariant="inline"
          />
        </div>
      </DialogContent>
    </V2Dialog>
  );
}
